import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class InsurerManagersService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/insurer_managers", { params: toSnakeCase(params) });
  }

  fetchShow(id) {
    return securedAxiosInstance.get(`/insurer_managers/${id}`);
  }

  create(params) {
    return securedAxiosInstance.post("/insurer_managers", toSnakeCase(params));
  }

  update(id, params) {
    return securedAxiosInstance.patch(`/insurer_managers/${id}`, toSnakeCase(params));
  }
}

export default new InsurerManagersService();
